import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'

import { formatProvidedInputValue } from '@/utils/matisseV2/toLabColor'

function Inputs({ recipe }) {
  const provided = recipe?.provided_input ?? {}
  const target = (region: 'cervical' | 'middle' | 'incisal') =>
    provided[`targetcolor_${region}`] ??
    provided[`target${region}`] ??
    provided[`target${region === 'middle' ? 'middle' : region}`]

  return (
    <>
      <Table sx={{ width: '100%', tableLayout: 'fixed', color: 'black' }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ color: 'black' }} />
            <TableCell sx={{ color: 'black' }}>
              <Typography fontWeight="bold" color="black">
                Cervical
              </Typography>
            </TableCell>
            <TableCell sx={{ color: 'black' }}>
              <Typography fontWeight="bold" color="black">
                Middle
              </Typography>
            </TableCell>
            <TableCell sx={{ color: 'black' }}>
              <Typography fontWeight="bold" color="black">
                Incisal
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell sx={{ color: 'black' }}>
              <Typography fontWeight="bold" color="black">
                Target
              </Typography>
            </TableCell>
            <TableCell sx={{ color: 'black' }}>
              {formatProvidedInputValue(target('cervical')) || '-'}
            </TableCell>
            <TableCell sx={{ color: 'black' }}>
              {formatProvidedInputValue(target('middle')) || '-'}
            </TableCell>
            <TableCell sx={{ color: 'black' }}>
              {formatProvidedInputValue(target('incisal')) || '-'}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <hr style={{ background: 'black', opacity: 1, margin: 0 }} />
    </>
  )
}

export default Inputs
